import React from 'react';
import { Handle, Position } from '@xyflow/react';
import './TechnologyCardNode.css';

class TechnologyCardNode extends React.Component
{
    state =
    {
        isSelected: false
    };

    onMouseEnter = () => {
        this.setState({ isSelected: true });
    }

    onMouseLeave = () => {
        this.setState({ isSelected: false });
    }

    render()
    {
        const technology = this.props.data.technology;
        const wikiUrl = "https://obsidiagon.com/kingdomwars/wiki/doku.php?id=technologies#" + technology;
        const isSelected = this.state.isSelected;
        const nodeClass = isSelected ? "technology-card-node-selected" :  "technology-card-node";
        const iconClass = isSelected ? "technology-card-icon-selected" :  "technology-card-icon";

        return (
        <>
            <Handle type="source" position={Position.Right} />
            <Handle type="target" position={Position.Left} />
            <div className={nodeClass} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <a target="_blank" rel="noopener noreferrer" href={wikiUrl}>
                <img className={iconClass} src={require('../Resources/' + technology + '.png')} alt="imageNotFound"/>
                </a>
                {isSelected && (<span className='technology-card-title'>{technology}</span>)}
            </div>
        </>
        );
    }
}

export default TechnologyCardNode;